import { useState } from 'react'

import classNames from 'classnames'

import type { IconTypes } from '../Icon/Icon'
import { Icon } from '../Icon/Icon'
import Link from '../Link/Link'
import Text, { TextSizes } from '../Text/Text'

import styles from './Lozenge.module.css'

export enum LozengeVariant {
  dark = 'dark',
  dashed = 'dashed',
  small = 'small',
  gray = 'gray',
  white = 'white',
  directory = 'directory',
  ghost = 'ghost',
  ghostDark = 'ghostDark',
}
export interface LozengeProps {
  title?: string
  count?: number | string
  link?: string
  onClick?: (evt: React.FormEvent<HTMLButtonElement>) => void
  iconClick?: (evt: any) => void
  hideOnZero?: boolean
  className?: string
  testID?: string
  isActive?: boolean
  variant?: LozengeVariant
  icon?: IconTypes
  iconPosition?: 'left' | 'right'
  size?: 'small' | 'medium' | 'large'
  testAttr?: string
  disabled?: boolean
}

export default function Lozenge({
  title,
  link,
  count = 0,
  hideOnZero = false,
  onClick,
  className,
  testID,
  isActive = false,
  iconClick,
  variant,
  icon,
  iconPosition = 'left',
  size,
  testAttr,
  disabled = false,
}: LozengeProps) {
  const [hoverClass, setHoverClass] = useState<any | null>(null)
  const handleClick = (evt: any) => {
    onClick?.(evt)
  }
  const countIsNumber = typeof count !== 'string'

  let showCounter = false
  if (!countIsNumber && count === 'x') {
    showCounter = true
  }
  if (
    countIsNumber &&
    ((hideOnZero && count > 0) || (!hideOnZero && (count as number) >= 0))
  ) {
    showCounter = true
  }

  const renderInner = () => {
    return (
      <>
        {icon && iconPosition === 'left' && (
          <div className={styles.svgIcon}>
            <Icon type={icon} />
          </div>
        )}
        <Text size={TextSizes.secondaryTitleMicro} uppercase={true}>
          {title}
        </Text>
        {iconPosition === 'right' && icon ? (
          <div className={styles.svgIcon}>
            <Icon type={icon} />
          </div>
        ) : (
          showCounter && (
            <div
              className={classNames([
                styles.count,
                countIsNumber === false && styles.countString,
              ])}
              onClick={e => {
                if (iconClick) {
                  e.stopPropagation()
                  setHoverClass(null)
                  iconClick(e)
                }
              }}
              data-testid={testID && `count-${testID}`}
            >
              <Text size={TextSizes.bodySml} className={styles.count}>
                {count}
              </Text>
            </div>
          )
        )}
      </>
    )
  }

  return (
    <>
      {link ? (
        <Link
          className={classNames(
            variant && styles[variant],
            styles.button,
            styles.buttonHover,
            isActive && styles.buttonActive,
            'mabLozenge',
            isActive && 'mabLozengeActive',
            className && className,
            size && styles[size]
          )}
          testID={testID && `link-${testID}`}
          href={link}
          onClick={evt => handleClick(evt)}
          data-test={testAttr}
        >
          {renderInner()}
        </Link>
      ) : (
        <button
          className={classNames(
            styles.button,
            hoverClass && hoverClass,
            isActive && styles.buttonActive,
            'mabLozenge',
            isActive && 'mabLozengeActive',
            className && className,
            showCounter && 'mabLozengeHasCount',
            showCounter && styles.buttonHasCount,
            variant && styles[variant],
            size && styles[size],
            disabled && styles.buttonDisabled
          )}
          onMouseEnter={() => setHoverClass(styles.buttonHover)}
          onMouseLeave={() => setHoverClass(null)}
          data-testid={testID && `button-${testID}`}
          data-test={testAttr}
          onClick={evt => {
            setHoverClass(null)
            handleClick(evt)
          }}
        >
          {renderInner()}
        </button>
      )}
    </>
  )
}
